// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-components-habitaciones-jsx": () => import("./../src/components/Habitaciones.jsx" /* webpackChunkName: "component---src-components-habitaciones-jsx" */),
  "component---src-pages-404-js": () => import("./../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-nosotros-js": () => import("./../src/pages/nosotros.js" /* webpackChunkName: "component---src-pages-nosotros-js" */)
}

